import { Users } from 'api';

export const resetPasswordFetcher = userData => {
  return Users.update(
    userData.userId,
    { email: userData.email, newPassword: userData.newPassword },
    '/updatePassword'
  );
};
